import React from 'react';
import {ReactElement} from 'react';

import {Link} from 'react-router-dom';

export default function HomePage(): ReactElement {
  return (
    <div style={{fontFamily: 'sans-serif', padding: '2rem'}}>
      <h1>PureTime Watch Faces</h1>
      <ul>
        <li>
          <Link to="/octo">Octo</Link>
        </li>
        <li>
          <Link to="/neu">Neu</Link>
        </li>
      </ul>
    </div>
  );
}
